<template>
    <div :class="['ui-alert', className]">
        <i><svg-icon :name="svgName" /></i>
        <!-- {{ text }} -->
        <div v-html="text"></div>
        <slot></slot>
    </div>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon.vue';

export default {
    name: 'SettingsAlert',

    components: {
        SvgIcon
    },

    props: {
        className: {
            type: [String, Object, Array],
            default: 'green'
        },

        text: {
            type: String,
            default: ''
        },

        svgName: {
            type: String,
            default: 'alert'
        }
    },

    // mounted() {
    //     document.addEventListener('click', (e) => {
    //         if (e.target.classList.contains('notify-link')) {
    //             this.$router.push('/help');
    //         }
    //     });
    // },
}
</script>
<style lang="scss">
.ui-alert {
    margin-bottom: 20px;
    padding: 8px 10px;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    color: var(--black-90);

    i {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        display: flex;
        align-items: center;
    }

    svg {
        width: 100%;
        height: 100%;
        
        fill: var(--black-75);
    }

    a {
        white-space: nowrap;
    }

    &.yellow {
        background: var(--light-yellow)
    }

    &.green {
        background: rgba(232, 248, 242, 1);
    }
}
</style>

